import ConfirmationModal from '@/components/ConfirmationModal.vue';
import { defineStore } from 'pinia';
import { reactive, ref } from 'vue';

export const useConfirmationStore = defineStore('confirmation', () => {
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);

    const init = (_confirmationModalRef: any) => {
        confirmationModalRef.value = _confirmationModalRef.value;
    }

    const open = (title: string, message: string) => {
        if (!confirmationModalRef.value) { return; }

        return confirmationModalRef.value!.open(title, message)
    };

    return { init, open };
});